import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

export default function PageShell({ children }) {
  return (
    <div className="min-h-screen bg-[#FBFBFC] text-[#0B1120]">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}